<template>
  <div>
    <app-breadcrumb>
      <template #contentright>
        <span></span>
      </template>
    </app-breadcrumb>
    <div class="card">
      <div class="card-body p-1">
        <div class="row">
          <b-col cols="12" md="4" class="mb-md-0 mb-2">
            <label>Tiều đề</label>
            <b-input-group>
              <b-form-input v-model="localSearchQuery" class="d-inline-block" @keyup.enter="updateSearchQuery"
                placeholder="Tiêu đề bài viết" />
            </b-input-group>
          </b-col>
          <div class="col-12 col-md-4">
            <label>Chuyên mục</label>
            <v-select v-model="category_id" :options="all_cats" class="w-100" label="name" :reduce="val => val.id"
              placeholder="--Chọn--" @input="(val) => $emit('update:type', val)" />
          </div>
          <div class="col-12 col-md-3">
            <label>Phòng ban</label>
            <v-select v-model="department_id" :options="dataDepartment" class="w-100" label="name" :reduce="val => val.id"
              placeholder="--Chọn--" @input="(val) => $emit('update:type', val)" />
          </div>
          <div class="col-12 col-md-2">
            <b-button variant="primary" style="margin-top:1.7rem" @click="updateSearchQuery">
              <feather-icon icon="SearchIcon" /> Tìm kiếm </b-button>
          </div>
        </div>
      </div>
    </div>
    <b-overlay :show="loading" spinner-variant="primary" spinner-type="grow" spinner-small rounded="sm">
      <div class="card">
        <b-table ref="refListTable" class="table-responsive table-nowrap" :items="itemsData" responsive
          :fields="tableColumns" primary-key="id" :sort-by.sync="sortBy" :sort-desc.sync="isSortDirDesc" show-empty
          empty-text="Không tìm thấy bản ghi nào">
          <!-- Column: Status -->
          <template #cell(status)="data">
            <b-badge :variant="data.item.statusText.color"> {{ data.item.statusText.name }} </b-badge>
          </template>
          <template #cell(title)="data">
            <div class="d-flex flex-column">
              <span class="link" @click="onPreview(data.item.id)"><b>{{ data.item.title }} </b>
                <span v-for="(icon, index) in  data.item.content_type" :key="index" :class="`icon` + icon"></span>
              </span>
              <span class="text1">{{ data.item.category.name }}</span>
            </div>
          </template>
          <template #cell(actions)="data">
            <div v-for="(button, index) in data.item.listButton" :key="index">
              <b-button v-if="button.type == 'link'" size="sm" :variant="button.color" :title="button.title"
                :to="{ name: button.url, params: { id: data.item.id } }">
                <span class="text-nowrap">
                  <feather-icon :icon="button.icon" /> </span>
              </b-button>
              <b-button v-if="['restore', 'delete'].includes(button.type)" size="sm" :variant="button.color"
                :title="button.title" @click="updateStatus(button.type, data.item.id)">
                <span class="text-nowrap">
                  <feather-icon :icon="button.icon" /> {{ button.title }} </span>
              </b-button>
            </div>
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-start">
              <span class="text-muted">Hiển thị {{ dataMeta.from }} đến {{ dataMeta.to }} của {{ dataMeta.of }} mục</span>
            </b-col>
            <!-- Pagination -->
            <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">
              <b-pagination v-model="currentPage" :total-rows="total" :per-page="perPage" first-number last-number
                class="mb-0 mt-1 mt-sm-0" prev-class="prev-item" next-class="next-item">
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-overlay>
    <b-modal id="showPreview" size="lg" cancel-variant="outline-secondary" no-close-on-backdrop hide-footer
      title="Xem thử bài viết">
      <article-preview :article_id="article_id" :type_view="type_view" @updateList="handleListData" />
    </b-modal>
  </div>
</template>
<script>

import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
  BBadge, BModal, BPagination, BInputGroupAppend, BInputGroup, BOverlay
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import {
  ref, watch, computed, onMounted,
} from '@vue/composition-api'
import store from '@/store'
import { useRouter, showToast } from '@core/utils/utils';
import AppBreadcrumb from '@core/layouts/components/AppBreadcrumb.vue'
import useJwt from '@/auth/jwt/useJwt';
import ArticlePreview from './ArticlePreview.vue'

export default {
  components: {
    BCard,
    BOverlay,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BModal,
    BTable,
    BLink,
    BBadge,
    BPagination,
    BInputGroupAppend,
    AppBreadcrumb,
    BInputGroup,
    vSelect,
    ArticlePreview,
  },
  data() {
    return {
      type_view: 'show',
      article_id: '',
    }
  },
  setup(props, context) {
    const { route, router } = useRouter();
    const refListTable = ref(null)
    const dataUser = useJwt.getUser();

    // Table Handlers
    const tableColumns = [
      { key: 'title', sortable: false, label: 'Tiêu đề' },
      {
        key: 'deleted_at', sortable: false, label: 'Ngày xóa', class: 'deleted_at', thAttr: { width: '12%' },
      },
      {
        key: 'actions', label: 'Hành động', thAttr: { width: '20%' }, tdClass: 'action2 flexitem text-center', thClass: 'action text-left',
      },
    ];

    const perPage = ref(30)
    const total = ref(0)
    const currentPage = ref(1)
    const perPageOptions = [10, 30, 50, 100]
    const searchQuery = ref('')
    const sortBy = ref('id')
    const isSortDirDesc = ref(true)
    const department_id = ref('')
    const category_id = ref('')
    const localSearchQuery = ref('')
    const itemsData = ref([]);
    const all_cats = ref([]);
    const loading = ref(true)
    const dataDepartment = ref([]);
    const from = ref(0)
    const to = ref(0)

    const fetchAll = (isPaginate) => {
      isPaginate = isPaginate === undefined ? 0 : isPaginate;
      if (!isPaginate) {
        loading.value = true
      }
      store.dispatch('article/fetchAll', {
        keyword: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        category_id: category_id.value,
        department_id: department_id.value,
        card_type: 'deleted',
        sortDesc: isSortDirDesc.value,
        isPaginate
      })
        .then(response => {
          const result = response.data;
          loading.value = false
          if (result.code === 200) {
            if (isPaginate) {
              from.value = result.data.from;
              to.value = result.data.to;
              total.value = result.data.total;
            } else {
              itemsData.value = result.data.data
              //total.value = result.data.total;
              if (Object.keys(result.data.all_cats).length > 0) {
                all_cats.value = result.data.all_cats;
              }
              setTimeout(() => {
                fetchAll(1);
              }, 1000);
            }
          }
        })
    }
    const dataMeta = computed(() => {
      const localItemsCount = refListTable.value ? refListTable.value.localItems.length : 0
      return {
        from: from.value,
        to: to.value,
        of: total.value,
      }
    })


    watch([currentPage, perPage, searchQuery, department_id, category_id, sortBy], () => {
      refetchData()
    })

    const refetchData = () => {
      fetchAll()
    }

    const fetchDepartment = () => {
      store.dispatch('departments/fetchDepartments', {
        type: 'all',
      })
        .then(response => {
          if (response.data.code === 200) {
            dataDepartment.value = response.data.data;
          }
        })
    }
    fetchDepartment();

    const updateSearchQuery = () => {
      searchQuery.value = localSearchQuery.value
    }

    onMounted(() => {
      fetchAll()
    })

    return {
      fetchAll,
      loading,
      tableColumns,
      perPage,
      currentPage,
      total,
      dataMeta,
      perPageOptions,
      sortBy,
      isSortDirDesc,
      refListTable,
      refetchData,
      all_cats,
      department_id,
      category_id,
      updateSearchQuery,
      localSearchQuery,
      itemsData,
      dataUser,
      dataDepartment,
    }
  },
  mounted() {
    this.$store.commit('verticalMenu/UPDATE_VERTICAL_MENU_COLLAPSED', false);
  },
  methods: {
    handleListData(type = false) {
      this.refetchData();
      if (type) {
        this.$bvModal.hide('showPreview')
      }
    },
    onPreview(id) {
      this.article_id = id;
      this.$bvModal.show('showPreview');
    },
    updateStatus(type, article_id) {
      const text_message = (type == 'restore') ? 'Bạn có chắc chắn muốn khôi phục bài viết này không?' : 'Bạn có chắc chắn muốn xóa hẳn bài viết này không?';
      this.$swal({
        title: '',
        text: text_message,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Có',
        cancelButtonText: 'Không',
        customClass: {
          confirmButton: 'btn btn-success',
          cancelButton: 'btn btn-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.isConfirmed) {
          if (type == 'restore') {
            const id = article_id;
            store.dispatch('article/restore', { id })
              .then(response => {
                const result = response.data;
                if (result.code == 200) {
                  this.refetchData();
                  // showToast(result.message, { variant: 'success' })
                } else {
                  showToast(result.message)
                }
              })
          } else {
            const params = {
              type: 'delete',
              ids: [article_id],
            }
            store.dispatch('article/destroy', params).then(response => {
              const result = response.data;
              if (result.code == 200) {
                this.refetchData();
                showToast(result.message, { variant: 'success' })
              } else {
                showToast(result.message);
              }
            })
          }
        }
      })
    },

  },
}
</script>

<style lang="scss">
.link {
  color: #000;
  font-weight: bold;

  &:hover {
    color: #e63631
  }
}

@import '@core/scss/vue/libs/vue-select.scss';
</style>
